var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOffWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_304363",
    "data-name": "Group 304363",
    transform: "translate(-523.146 -726.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18741",
    "data-name": "Group 18741",
    transform: "translate(523.146 726.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_193",
    "data-name": "Subtraction 193",
    d: "M6.708,15H2.755a.454.454,0,0,1-.459-.486.517.517,0,0,1,.115-.334.434.434,0,0,1,.344-.152H4.261V11.7A4.16,4.16,0,0,1,.637,7.527V6.993a.452.452,0,0,1,.471-.473.452.452,0,0,1,.471.473v.534a3.246,3.246,0,0,0,3.153,3.252A3.076,3.076,0,0,0,6.995,9.772l-.78-.8a2.07,2.07,0,0,1-1.483.6,2.074,2.074,0,0,1-1.391-.51,1.983,1.983,0,0,1-.632-1.529V5.351L0,2.56l.433-.445L9.9,11.879l.1.1-.433.447-1.9-1.962A4.064,4.064,0,0,1,5.2,11.7v2.328H6.708a.486.486,0,0,1,0,.971ZM8.5,9.177h0l-.737-.76a3.249,3.249,0,0,0,.124-.889V6.993a.47.47,0,1,1,.941,0v.534A4.285,4.285,0,0,1,8.5,9.176Zm-1.744-1.8,0,0L2.707,3.205V2.075A1.962,1.962,0,0,1,4.731,0,1.962,1.962,0,0,1,6.754,2.075v5.3Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOffWhite);
export default __webpack_public_path__ + "static/media/MicOffWhite.1bc02b93b391861a75c53aef65c70c95.svg";
export { ForwardRef as ReactComponent };